export default __webpack_public_path__ + "images/line-chart-dummy-140.11fceed85728df46f1efe33451ae8bfc.svg";